import {
    GET_SELECTED_CORPORATE,
    GET_SELECTED_SUPERCORPORATE,
    GET_BULK_PAYMENT_INFO
} from "../types/cpayAppType";

const initialState = {
    selectedCorporateId: "",
    selectedSuperCorporateId: "",
    bulkPaymentInfo: {},
    paymentReference: ""
};

const cpayAppReducer = (state = initialState, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_SELECTED_CORPORATE:
            return {
                ...state,
                selectedCorporateId: payload
            };
        case GET_SELECTED_SUPERCORPORATE:
            return {
                ...state,
                selectedSuperCorporateId: payload
            };
        case GET_BULK_PAYMENT_INFO:
            return {
                ...state,
                bulkPaymentInfo: payload
            };
        default:
            return state;
    }
};

export default cpayAppReducer;
